import { render } from "./TempPage.vue?vue&type=template&id=3647e56b"
import script from "./TempPage.vue?vue&type=script&lang=js"
export * from "./TempPage.vue?vue&type=script&lang=js"

import exportComponent from "G:\\Threejs\\VuejsThreejsForDemo-main\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__